import React, { FC } from 'react';
import { Button, Form } from 'react-bootstrap';
import { urls } from '../../services/Server';
import { AssetWithCalculatedStats } from '../../interfaces/interfaces';

interface Props {
  asset: AssetWithCalculatedStats;
}

const SellPortfolioAsset: FC<Props> = ({ asset }) => {
  const { type, id } = asset;
  const action = type === 'Crypto' ? urls.sellCrypto : urls.sellEquity;
  return (
    <form action={action} method="post">
      <h4>Selg andeler</h4>
      <input type="hidden" name="equityId" value={id} />
      <Form.Group controlId="numSold">
        <label htmlFor="numSold"> Antall solgt</label>
        <Form.Control
          required
          type="number"
          name="numSold"
          step="0.0000000001"
          placeholder="F.eks: 3.14159"
        />
      </Form.Group>
      <Form.Group>
        <Button variant="danger" type="submit">
          Selg
        </Button>
      </Form.Group>
    </form>
  );
};

export default SellPortfolioAsset;
